module.exports = __webpack_public_path__ + "static/media/gc-street-good.b1be95bb.png";